import React from "react";
import { IShowRunTimeSlot } from "@eagerdog/interfaces";

import './TimeSlot.scss';

interface IProps {
  timeslot: IShowRunTimeSlot,
  className?: string,
  waitlistEnabled?: boolean,
  estimatedWaitlistPosition?: number,
  onClick?(e: any): void
}

const TimeSlot: React.FC<IProps> = (props) => {
  const slotsAvailable = props.timeslot.num_available - props.timeslot.num_reserved;
  const isFull = slotsAvailable <= 0;

  let slotsLabel: string;
  if (!isFull) {
    slotsLabel = `${slotsAvailable} Slots Available`;
  } else if (props.estimatedWaitlistPosition != null) {
    slotsLabel = `Waitlist - Position ${props.estimatedWaitlistPosition}`;
  } else if (props.waitlistEnabled) {
    slotsLabel = 'Join Waitlist';
  } else {
    slotsLabel = 'Full';
  }

  return (
    <div onClick={props.onClick} className={"TimeSlot " + props.className || ""}>
      <span className="label">{props.timeslot.time_slot}</span>
      <span className="slots">{slotsLabel}</span>
      {props.timeslot.note && <span className="note">{props.timeslot.note}</span>}
    </div>
  );
};

export default TimeSlot;